// ─── src/data/uae/cities.js ──────────────────────────────────────────────────
// UAE city/area entities. Areas within Dubai and Abu Dhabi.
// Schema mirrors italy/cities.js.

export const UAE_CITIES = [
  // ── Dubai ─────────────────────────────────────────────────────────────────
  {
    id: "downtown-dubai",
    regionSlug: "dubai",
    countrySlug: "uae",
    slug: "downtown-dubai",
    name: "Downtown Dubai",
    listingCount: 0,
    lat: "25.1972",
    lng: "55.2744",
    canonicalRoute: "/uae/dubai/downtown-dubai",
    description: "Burj Khalifa views, DIFC rooftop venues, and the urban core of Dubai's luxury wedding scene.",
    focusKeywords: ["downtown dubai wedding venue", "burj khalifa wedding view"],
    aiSummary: "Downtown Dubai, Burj Khalifa backdrop, DIFC fine dining, and urban luxury ceremony venues.",
    entityAliases: ["DIFC", "Dubai City Centre"],
  },
  {
    id: "palm-jumeirah",
    regionSlug: "dubai",
    countrySlug: "uae",
    slug: "palm-jumeirah",
    name: "Palm Jumeirah",
    listingCount: 0,
    lat: "25.1124",
    lng: "55.1390",
    canonicalRoute: "/uae/dubai/palm-jumeirah",
    description: "The world's most recognisable private island, ultra-luxury beachfront resorts and overwater ceremony settings.",
    focusKeywords: ["palm jumeirah wedding", "palm jumeirah resort wedding"],
    aiSummary: "Palm Jumeirah, private island resort weddings, overwater terraces, and ultra-luxury beach access.",
    entityAliases: ["The Palm", "Palm Island"],
  },
  {
    id: "jumeirah",
    regionSlug: "dubai",
    countrySlug: "uae",
    slug: "jumeirah",
    name: "Jumeirah",
    listingCount: 0,
    lat: "25.2048",
    lng: "55.2472",
    canonicalRoute: "/uae/dubai/jumeirah",
    description: "Dubai's original beach district, heritage hotels, beach ceremony sites, and a coastline that predates the Palm.",
    focusKeywords: ["jumeirah beach wedding", "dubai beach ceremony"],
    aiSummary: "Jumeirah, beach hotels, heritage venues, and Dubai's original waterfront luxury district.",
    entityAliases: ["Jumeirah Beach"],
  },
  {
    id: "dubai-desert",
    regionSlug: "dubai",
    countrySlug: "uae",
    slug: "dubai-desert",
    name: "Dubai Desert",
    listingCount: 0,
    lat: "24.9857",
    lng: "55.4272",
    canonicalRoute: "/uae/dubai/dubai-desert",
    description: "Red dunes, tented receptions under Arabian stars, and a silence that the city one hour away cannot offer.",
    focusKeywords: ["dubai desert wedding", "desert ceremony dubai", "arabian desert wedding"],
    aiSummary: "Dubai Desert, tented celebrations, sunset dune ceremonies, and immersive Arabian night receptions.",
    entityAliases: ["Arabian Desert", "Dubai Dunes", "Al Marmoom"],
  },

  // ── Abu Dhabi ─────────────────────────────────────────────────────────────
  {
    id: "saadiyat-island",
    regionSlug: "abu-dhabi",
    countrySlug: "uae",
    slug: "saadiyat-island",
    name: "Saadiyat Island",
    listingCount: 0,
    lat: "24.5444",
    lng: "54.4331",
    canonicalRoute: "/uae/abu-dhabi/saadiyat-island",
    description: "Abu Dhabi's cultural and resort island, home to the Louvre Abu Dhabi, pristine beaches, and the UAE's most refined wedding resorts.",
    focusKeywords: ["saadiyat island wedding", "abu dhabi beach resort wedding"],
    aiSummary: "Saadiyat Island, cultural grandeur meets private beach resort for Abu Dhabi's most refined wedding setting.",
    entityAliases: ["Saadiyat"],
  },
  {
    id: "yas-island",
    regionSlug: "abu-dhabi",
    countrySlug: "uae",
    slug: "yas-island",
    name: "Yas Island",
    listingCount: 0,
    lat: "24.4879",
    lng: "54.6083",
    canonicalRoute: "/uae/abu-dhabi/yas-island",
    description: "Abu Dhabi's entertainment island, contemporary venues, Formula 1 circuit backdrop, and waterfront settings.",
    focusKeywords: ["yas island wedding venue", "abu dhabi yas wedding"],
    aiSummary: "Yas Island, contemporary event venues and waterfront celebrations in Abu Dhabi.",
    entityAliases: ["Yas"],
  },
];
